// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"2b5732f0","362":"2426e388","534":"bc5f8d2d","656":"7eee7ed8","802":"b96b7e01","896":"71205087"}[chunkId] + ".chunk.js";
};